
import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '@/contexts/MyContext';
import { Navigate } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card } from '@/components/ui/card';
import ContentManager from '@/components/admin/ContentManager';
import UserManager from '@/components/admin/UserManager';
import SalesManager from '@/components/admin/SalesManager';
import { ChartBar, Users } from 'lucide-react';
import { useToast } from '@/components/ui/use-toast';
// import { Admin } from 'react-admin';
import { dataProvider } from '@/lib/supabase';
import authProvider from '@/lib/adminAuthProvider';
import { Admin, Resource } from 'react-admin';
import { UserList } from '@/components/admin/lists';

const Admins = () => {
  const { user, logout, getAllUsers } = useAuth();
  const [refreshKey, setRefreshKey] = useState(0);
  const { toast } = useToast();
  
  // Force refresh function using useCallback to prevent recreation on each render
  // const forceRefreshUsers = useCallback(async () => {
  //   try {
  //     // Directly get users from localStorage and update context
  //     const rawUsers = localStorage.getItem("allUsers");
      
  //     if (rawUsers) {
  //       // Force context to reload users
  //       const users = await getAllUsers();
  //       console.log("Admin panel force refreshed user data, count:", users.length);
        
  //       // Increment refresh key to force UserManager component to re-render
  //       setRefreshKey(prev => prev + 1);
  //     } else {
  //       console.log("No users found in localStorage");
        
  //       // Initialize localStorage with mock users if empty
  //       localStorage.setItem("allUsers", JSON.stringify([
  //         {
  //           id: '1',
  //           email: 'demo@example.com',
  //           name: 'Demo User',
  //           memberships: ['course'],
  //           locked: false,
  //           courseProgress: []
  //         },
  //         {
  //           id: '2',
  //           email: 'support@applaunchai.com',
  //           name: 'Admin User',
  //           memberships: ['all'],
  //           locked: false,
  //           isAdmin: true
  //         }
  //       ]));
        
  //       // Reload users after initialization
  //       getAllUsers();
  //       setRefreshKey(prev => prev + 1);
  //     }
  //   } catch (e) {
  //     console.error("Error refreshing users:", e);
  //     toast({
  //       title: "Error Refreshing Users",
  //       description: "There was a problem loading the user data. Please try again.",
  //       variant: "destructive",
  //     });
  //   }
  // }, [getAllUsers, toast]);
  
  // Initial load and refresh on component mount - with reduced polling frequency
  // useEffect(() => {
  //   if (user?.isAdmin) {
      // Initial load
      // forceRefreshUsers();
      
      // Set up less frequent refresh interval to reduce re-renders
      // const interval = setInterval(() => {
      //   forceRefreshUsers();
      // }, 30000); // Changed to 30 seconds instead of 5 seconds
      
      // Clean up interval on unmount
  //     return () => clearInterval(interval);
  //   }
  // }, [user, forceRefreshUsers]);
  
  // If user is locked, log them out
  // useEffect(() => {
  //   if (user?.locked) {
  //     logout();
      
  //     toast({
  //       title: "Account Locked",
  //       description: "Your account has been locked by an administrator.",
  //       variant: "destructive",
  //     });
  //   }
  // }, [user, logout, toast]);
  
  // if (!user) {
  //   return <Navigate to="/login" />;
  // }
  
  // Check if user has admin privileges
  console.log(user, 'from admin page.')
  const isAdmin = user?.isAdmin === true;
  
  if (!isAdmin) {
    return (
      <div className="container mx-auto px-4 py-12 text-center">
        <h1 className="text-3xl font-bold text-red-500">Access Denied</h1>
        <p className="mt-4">You don't have permission to access the admin dashboard.</p>
      </div>
    );
  }

  return (
    // <Admin dataProvider={dataProvider} authProvider={authProvider}>
    //   <Resource name="users" list={UserList} />
    // </Admin>
    <div  className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold">Admin Dashboard</h1>
        <p className="text-gray-600">Manage course content and user memberships</p>
      </div>
      
      <Tabs defaultValue="users" className="w-full">
        <TabsList className="mb-6">
          <TabsTrigger value="content">Course Content</TabsTrigger>
          <TabsTrigger value="users">
            <Users className="mr-2 h-4 w-4" /> User Management
          </TabsTrigger>
          <TabsTrigger value="sales">
            <ChartBar className="mr-2 h-4 w-4" /> Sales Statistics
          </TabsTrigger>
        </TabsList>
        
        <TabsContent value="content">
          <Card className="p-6">
            <ContentManager />
          </Card>
        </TabsContent>
        
        <TabsContent value="users">
          <Card className="p-6">
            <UserManager key={refreshKey}  />
          </Card>
        </TabsContent>
        
        <TabsContent value="sales">
          <Card className="p-6">
            <SalesManager />
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Admins;
